import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SIDEBAR_ITEMS } from '../../constants/sidebar.constant';
import { ImageEnum } from '../../utils/image.enum';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css',
})
export class Sidebar {
  @Input() isMobileOpen = false;
  @Input() isCollapsed = false;

  @Output() mobileOpenChange = new EventEmitter<boolean>();
  @Output() collapsedChange = new EventEmitter<boolean>();

  protected readonly imageEnum = ImageEnum;
  protected readonly navItems = SIDEBAR_ITEMS;

  closeMobileSidebar(): void {
    this.mobileOpenChange.emit(false);
  }

  toggleCollapsed(): void {
    this.collapsedChange.emit(!this.isCollapsed);
  }
}
